import React from "react";
import PropTypes from "prop-types";
import { Route,Link } from "react-router-dom";
import auth from "../services/authService";

const ProtectedRoute = ({ component: Component, render, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        if (!auth.getCurrentUser())
          return (
            <Link
              to={{
                pathname: "/AdminLogin",
                state: { from: props.location },
              }}
            />
          );
        return Component ? <Component {...props} /> : render(props);
      }}
    />
  );
};

ProtectedRoute.propTypes = {};

export default ProtectedRoute;
